import React, { useEffect, useState, useRef } from "react";
import { NavLink } from "react-router-dom";
import "./AcademiesContent.css";
import HomeNavbarmenu from "../HomeFolder/HomeNavbarmenu";
import HomeSideNavbar from "../HomeFolder/HomeSideNavbar";
import AOS from "aos";
import "aos/dist/aos.css";
import CubicBox from "./CubicBox";
import ClientAcademiesTab from "./ClientAcademiesTab";
import { useDispatch, useSelector } from "react-redux";
import { SearchBar } from "../../Pages/Search";
import { onChange } from "../Redux/SearchSlice";


function AcademiesContent() {
  const tabLabels = ["Entry Level", "Tracks", "Client Academies"];
  const [activeTab, setActiveTab] = useState(tabLabels[1]);
  const [activeIndex, setActiveIndex] = useState(1);
  const tabContainerRef = useRef(null);


  const dispatch = useDispatch()
     const onMouseClick = () =>{
             dispatch(onChange())
  }
  const selector = useSelector(state=>state.search.value)

  useEffect(() => {
    AOS.init({ duration: 800 });
    onMouseClick()
    setTimeout(() => {
      centerActiveTab(activeIndex);
    }, 200);
  }, []);

  const handleTabClick = (label, index) => {
    setActiveTab(label);
    setActiveIndex(index);
    centerActiveTab(index);
  };

  const handleArrowClick = (direction) => {
    let newIndex = activeIndex;
    if (direction === "left" && activeIndex > 0) newIndex--;
    if (direction === "right" && activeIndex < tabLabels.length - 1) newIndex++;
    setActiveTab(tabLabels[newIndex]);
    setActiveIndex(newIndex);
    centerActiveTab(newIndex);
  };

  const centerActiveTab = (index) => {
    const container = tabContainerRef.current;
    const tab = container?.children[index];
    if (container && tab) {
      const containerWidth = container.offsetWidth;
      const tabWidth = tab.offsetWidth;
      const scrollPosition = tab.offsetLeft - containerWidth / 2 + tabWidth / 2;
      container.scrollTo({ left: scrollPosition, behavior: "smooth" });
    }
  };

  return (
    <>
      <div className="navbar-holder">
        <HomeNavbarmenu />
      </div>
      <div className="home-sidenavbar-holder">
        <HomeSideNavbar />
      </div>
      {selector && selector!==""? <SearchBar/>: <>
      <div className="video-container" id="main">
        <title>L-TT Academies Tracks</title>
        <img
          src={
            process.env.PUBLIC_URL +
            "/images/Banners/Academies-Tracks-Mobile.png"
          }
          alt="home-banner"
          className="banner-img mobile-banner"
        />
        <img
          src={process.env.PUBLIC_URL + "/images/Banners/Academies-Tracks.png"}
          alt="Academies-Banner"
          className="banner-img desktop-banner"
        />
        <ul className="breadcrumbs">
          <li className="breadcrumbs-item">
            <NavLink
              activeClassName="is-active"
              className="breadcrumbs-links"
              to="/Home"
            >
              L&TT Home
            </NavLink>
            <span>/</span>
          </li>
          <li className="breadcrumbs-item">
            <NavLink
              activeClassName="is-active"
              className="breadcrumbs-links"
              to="/Academies-Tracks"
            >
              Academies & Tracks
            </NavLink>
          </li>
        </ul>
        <div className="all-headings-text-box">
          <h1 tabIndex={0}>Academies & Tracks</h1>
          <p>Elevate your capability with a suite of role-aligned</p>
          <p>
            Check out our academies and technology-specific tracks, curated to
            sharpen your expertise in high-demand areas and prepare you for what
            is next.
          </p>
        </div>
      </div>

      <section className="academies-tracks-section mobile-aca-trac" data-aos="fade-up">
        <div className="academies-tracks-wrap">
          {/* Mobile Arrows */}
          <button
            className="tab-arrow left-arrow"
            onClick={() => handleArrowClick("left")}
            aria-label="Scroll left"
          >
            &#10094;
          </button>

          <div className="tabs-container" ref={tabContainerRef}>
            {tabLabels.map((label, index) => {
              if (label === "Entry Level") {
                return (
                  <a
                    key={index}
                    href="https://atci.entrylevellearning.accenture.com"
                    className={`tab-item ${
                      activeTab === label ? "active" : ""
                    }`}
                    onClick={() => handleTabClick(label, index)}
                  >
                    {label}
                    {activeTab === label && <div className="tab-underline" />}
                  </a>
                );
              } else {
                return (
                  <div
                    key={index}
                    className={`tab-item ${
                      activeTab === label ? "active" : ""
                    }`}
                    onClick={() => handleTabClick(label, index)}
                  >
                    {label}
                    {activeTab === label && <div className="tab-underline" />}
                  </div>
                );
              }
            })}
          </div>

          <button
            className="tab-arrow right-arrow"
            onClick={() => handleArrowClick("right")}
            aria-label="Scroll right"
          >
            &#10095;
          </button>

          <div className="track-grid">
            {activeTab === "Tracks" && <CubicBox />}
            {activeTab === "Client Academies" && <ClientAcademiesTab />}
          </div>
        </div>
      </section>
      </>}
    </>
  );
}

export default AcademiesContent;
